/**
 * Ask the server for a Remix of a source episode. Returns { title,
 * description, angle } or throws. Free of charge — we don't decrement
 * credits for the remix idea itself, only when the user actually builds.
 */
export async function fetchRemixIdea({
  sourceEpisode,
  niche,
  showName,
  audience,
}) {
  const payload = {
    sourceTopic:  sourceEpisode?.topic || '',
    sourceTitle:  sourceEpisode?.result?.title || '',
    sourceFormat: sourceEpisode?.format || '',
    sourceHooks:  Array.isArray(sourceEpisode?.result?.hooks)
      ? sourceEpisode.result.hooks.map(h => h?.text || '').filter(Boolean)
      : [],
    niche, showName, audience,
  };
  const res = await fetch('/api/remix-idea', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.error) throw new Error(data.error || `Remix failed (${res.status})`);
  return data;
}
